import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { pick } from 'lodash';
import { NormalizeAddress } from 'src/app/interfaces/normalize-address';
import { AddressService } from 'src/app/services/address.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-normalize-addresses-modal',
  templateUrl: './normalize-addresses-modal.component.html',
  styleUrls: ['./normalize-addresses-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NormalizeAddressesModalComponent implements OnInit {
  private _cdr = inject(ChangeDetectorRef);
  constructor(
    private activeModal: NgbActiveModal,
    private AddressService: AddressService,
    private ToastService: ToastService
  ) {}

  @Input() mailingAddress!: NormalizeAddress;
  @Input() streetAddress!: NormalizeAddress;

  normalizedMailingAddress: NormalizeAddress | null = null;
  normalizedStreetAddress: NormalizeAddress | null = null;

  formattedMailingAddress!: string;
  formattedStreetAddress!: string;
  formattedNormalizedMailingAddress!: string;
  formattedNormalizedStreetAddress!: string;

  continue() {
    const normalizedAddresses = {
      mailingAddress: this.normalizedMailingAddress,
      streetAddress: this.normalizedStreetAddress
    };
    this.activeModal.close(normalizedAddresses);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  ngOnInit(): void {
    if (!this.mailingAddress) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot Normalize Address. No mailing address entered.',
        { returnError: true }
      );
    }

    if (!this.streetAddress) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot Normalize Address. No street address entered.',
        { returnError: true }
      );
    }

    const addressFieldsToPick = [
      'address1',
      'address2',
      'city',
      'state',
      'zip',
      'country'
    ];
    const mailingAddress = pick(
      this.mailingAddress,
      addressFieldsToPick
    ) as NormalizeAddress;
    const streetAddress = pick(
      this.streetAddress,
      addressFieldsToPick
    ) as NormalizeAddress;

    this.AddressService.batchVerifyAddresses([
      mailingAddress,
      streetAddress
    ]).subscribe({
      next: ([mailingAddress, streetAddress]) => {
        if (mailingAddress) {
          this.normalizedMailingAddress = mailingAddress;
          this.formattedMailingAddress = Object.values(
            pick(this.mailingAddress, addressFieldsToPick)
          ).join(' ');
          this.formattedNormalizedMailingAddress = Object.values(
            this.normalizedMailingAddress as {}
          ).join(' ');
        }

        if (streetAddress) {
          this.normalizedStreetAddress = streetAddress;
          this.formattedStreetAddress = Object.values(
            pick(this.streetAddress, addressFieldsToPick)
          ).join(' ');
          this.formattedNormalizedStreetAddress = Object.values(
            this.normalizedStreetAddress as {}
          ).join(' ');
        }

        this._cdr.markForCheck();
      },
      error: (err) => {
        throw this.ToastService.addErrorToast('Error', err.message, {
          returnError: true
        });
      }
    });
  }
}
